@if (isOpen()) {
  <div
    (click)="close()"
    class="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-6 overflow-y-auto bg-slate-950/75 backdrop-blur-xs transition-opacity cursor-pointer"
  >
    <!-- Contenedor del Modal -->
    <div
      (click)="$event.stopPropagation()"
      class="relative w-full max-w-xl bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-800 overflow-hidden z-10 transition-colors my-auto cursor-default text-left"
    >
      <!-- Modal Header -->
      <div class="px-5 py-4 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between bg-slate-50/80 dark:bg-slate-950/50">
        <div class="flex items-center space-x-3">
          <div class="w-9 h-9 rounded-xl bg-emerald-600/10 dark:bg-emerald-500/20 text-emerald-700 dark:text-emerald-400 flex items-center justify-center shadow-2xs">
            <app-icon name="settings" [size]="18" />
          </div>
          <div>
            <h3 class="text-base font-bold text-slate-900 dark:text-white">{{ game.t('settings.title') }}</h3>
            <p class="text-xs text-slate-500 dark:text-slate-400">Configuración, preferencias y Wallet de créditos personales</p>
          </div>
        </div>
        <button
          type="button"
          (click)="close()"
          id="btn-close-settings-modal"
          class="p-1.5 rounded-xl text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer transition-colors"
        >
          <app-icon name="x" [size]="18" />
        </button>
      </div>

      <!-- Pestañas del Modal -->
      <div class="flex border-b border-slate-200 dark:border-slate-800 px-5 pt-1.5 bg-slate-50/40 dark:bg-slate-950/20 space-x-2">
        <button
          type="button"
          (click)="setTab('preferences')"
          id="settings-tab-preferences"
          class="py-2.5 px-3.5 text-xs font-bold border-b-2 transition-all flex items-center space-x-2 cursor-pointer"
          [ngClass]="activeTab() === 'preferences' ? 'border-emerald-600 text-emerald-700 dark:text-emerald-400' : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200'"
        >
          <app-icon name="globe" [size]="15" />
          <span>{{ game.t('settings.tab_preferences') }}</span>
        </button>

        <!--<button
          type="button"
          (click)="setTab('wallet')"
          id="settings-tab-wallet"
          class="py-2.5 px-3.5 text-xs font-bold border-b-2 transition-all flex items-center space-x-2 cursor-pointer"
          [ngClass]="activeTab() === 'wallet' ? 'border-amber-500 text-amber-700 dark:text-amber-400' : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200'"
        >
          <app-icon name="coins" [size]="15" />
          <span>{{ game.t('settings.tab_wallet') }}</span>
          <span class="px-1.5 py-0.2 rounded-md font-mono text-[10px] bg-amber-100 dark:bg-amber-950/80 text-amber-800 dark:text-amber-300 font-semibold">
            {{ game.userClub().economy.subscriptionCredits }} CR
          </span>
        </button>-->

        <button
          type="button"
          (click)="setTab('profile')"
          id="settings-tab-profile"
          class="py-2.5 px-3.5 text-xs font-bold border-b-2 transition-all flex items-center space-x-2 cursor-pointer"
          [ngClass]="activeTab() === 'profile' ? 'border-emerald-600 text-emerald-700 dark:text-emerald-400' : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200'"
        >
          <app-icon name="users" [size]="15" />
          <span>{{ game.t('settings.tab_profile') }}</span>
        </button>
      </div>

      <!-- Contenido del Modal -->
      <div class="p-5 space-y-4.5 max-h-[75vh] overflow-y-auto">
        <!-- TAB 1: WALLET DEL MÁNAGER (CR)
        @if (activeTab() === 'wallet') {
          <div class="p-5 rounded-2xl bg-gradient-to-br from-amber-500/10 via-orange-500/5 to-amber-600/10 dark:from-amber-950/40 dark:via-orange-950/20 dark:to-amber-950/40 border border-amber-200/90 dark:border-amber-800/70 shadow-xs">
            <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <div>
                <div class="flex items-center space-x-2">
                  <span class="text-xs font-bold uppercase tracking-wider text-amber-800 dark:text-amber-400">{{ game.t('settings.wallet_balance') }}</span>
                  <span class="px-2 py-0.5 rounded-full text-[10px] font-bold bg-amber-200/80 dark:bg-amber-900/60 text-amber-900 dark:text-amber-300">
                    Fondos Personales
                  </span>
                </div>
                <div class="text-3xl font-black font-mono text-amber-700 dark:text-amber-300 mt-1">
                  {{ game.userClub().economy.subscriptionCredits }} <span class="text-xl font-bold">CR</span>
                </div>
              </div>

              <div class="text-left sm:text-right">
                <div class="text-xs text-slate-500 dark:text-slate-400">{{ game.t('settings.wallet_monthly_fee') }}:</div>
                <div class="text-sm font-bold font-mono text-slate-900 dark:text-white">100 CR / mes</div>
              </div>
            </div>

            <div class="mt-4 pt-3.5 border-t border-amber-200/60 dark:border-amber-800/50 flex flex-col sm:flex-row gap-2">
              <button
                type="button"
                (click)="paySubscription()"
                id="btn-modal-pay-subscription"
                class="flex-1 py-2.5 px-4 rounded-xl bg-amber-600 hover:bg-amber-700 active:bg-amber-800 text-white font-semibold text-xs transition-all flex items-center justify-center space-x-2 cursor-pointer shadow-xs active:scale-98"
              >
                <app-icon name="check-circle" [size]="15" />
                <span>{{ game.t('settings.wallet_pay_fee') }}</span>
              </button>
            </div>
          </div>

          <div class="p-3.5 rounded-xl bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 text-xs text-slate-600 dark:text-slate-300 space-y-1.5">
            <div class="flex items-center space-x-2 font-bold text-slate-900 dark:text-white">
              <app-icon name="shield" [size]="15" class="text-emerald-600 dark:text-emerald-400" />
              <span>{{ game.t('settings.wallet_title') }}</span>
            </div>
            <p class="leading-relaxed">
              {{ game.t('settings.wallet_explanation') }}
            </p>
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-2 pt-1 text-[11px] text-slate-500 dark:text-slate-400">
              <div class="flex items-center space-x-1.5">
                <app-icon name="check" [size]="13" class="text-emerald-500 shrink-0" />
                <span>{{ game.t('settings.wallet_benefit_fee') }}</span>
              </div>
              <div class="flex items-center space-x-1.5">
                <app-icon name="check" [size]="13" class="text-emerald-500 shrink-0" />
                <span>{{ game.t('settings.wallet_benefit_leagues') }}</span>
              </div>
              <div class="flex items-center space-x-1.5">
                <app-icon name="check" [size]="13" class="text-emerald-500 shrink-0" />
                <span>{{ game.t('settings.wallet_benefit_analytics') }}</span>
              </div>
            </div>
          </div>

          <div>
            <div class="flex items-center justify-between mb-2">
              <h4 class="text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400">
                {{ game.t('settings.wallet_recharge') }}
              </h4>
              <span class="text-[10px] text-slate-400">{{ game.t('settings.wallet_recharge_instant') }}</span>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
              <div class="p-3.5 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 hover:border-amber-400 dark:hover:border-amber-600 transition-colors flex flex-col justify-between space-y-3">
                <div>
                  <div class="text-xs font-bold text-slate-900 dark:text-white">Pack Inicial</div>
                  <div class="text-lg font-black font-mono text-amber-600 dark:text-amber-300 mt-0.5">+250 CR</div>
                  <div class="text-[11px] text-slate-500 dark:text-slate-400 mt-0.5">2.5 {{ game.t('settings.wallet_monthly_fee') }}</div>
                </div>
                <button
                  type="button"
                  (click)="topUpCredits(250)"
                  id="btn-topup-250"
                  class="w-full py-2 bg-amber-50 hover:bg-amber-100 dark:bg-amber-950/60 dark:hover:bg-amber-900/60 text-amber-900 dark:text-amber-300 border border-amber-300 dark:border-amber-800/80 rounded-lg text-xs font-bold cursor-pointer transition-colors"
                >
                  {{ game.t('settings.wallet_recharge_btn', { cr: 250 }) }}
                </button>
              </div>

              <div class="p-3.5 rounded-xl border-2 border-amber-500/80 dark:border-amber-500/60 bg-amber-50/20 dark:bg-amber-950/20 relative flex flex-col justify-between space-y-3 shadow-xs">
                <div class="absolute -top-2 right-3 px-1.5 py-0.2 rounded text-[9px] font-bold bg-amber-500 text-white uppercase tracking-wider">
                  {{ game.t('settings.wallet_popular') }}
                </div>
                <div>
                  <div class="text-xs font-bold text-slate-900 dark:text-white">Pack Mánager Pro</div>
                  <div class="text-lg font-black font-mono text-amber-600 dark:text-amber-300 mt-0.5">+500 CR</div>
                  <div class="text-[11px] text-slate-500 dark:text-slate-400 mt-0.5">5 {{ game.t('settings.wallet_monthly_fee') }}</div>
                </div>
                <button
                  type="button"
                  (click)="topUpCredits(500)"
                  id="btn-topup-500"
                  class="w-full py-2 bg-amber-600 hover:bg-amber-700 active:bg-amber-800 text-white rounded-lg text-xs font-bold cursor-pointer transition-colors shadow-xs"
                >
                  {{ game.t('settings.wallet_recharge_btn', { cr: 500 }) }}
                </button>
              </div>

              <div class="p-3.5 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 hover:border-amber-400 dark:hover:border-amber-600 transition-colors flex flex-col justify-between space-y-3">
                <div>
                  <div class="text-xs font-bold text-slate-900 dark:text-white">Pack Élite Club</div>
                  <div class="text-lg font-black font-mono text-amber-600 dark:text-amber-300 mt-0.5">+1.000 CR</div>
                  <div class="text-[11px] text-slate-500 dark:text-slate-400 mt-0.5">10 {{ game.t('settings.wallet_monthly_fee') }}</div>
                </div>
                <button
                  type="button"
                  (click)="topUpCredits(1000)"
                  id="btn-topup-1000"
                  class="w-full py-2 bg-amber-50 hover:bg-amber-100 dark:bg-amber-950/60 dark:hover:bg-amber-900/60 text-amber-900 dark:text-amber-300 border border-amber-300 dark:border-amber-800/80 rounded-lg text-xs font-bold cursor-pointer transition-colors"
                >
                  {{ game.t('settings.wallet_recharge_btn', { cr: 1000 }) }}
                </button>
              </div>
            </div>
          </div>
        } -->

        <!-- TAB 2: PREFERENCIAS & IDIOMA -->
        @if (activeTab() === 'preferences') {
          <!-- Aspecto del tema -->
          <div class="flex items-center justify-between p-4 rounded-xl border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-950">
            <div class="flex items-center space-x-3">
              <div class="w-8 h-8 rounded-lg bg-slate-200 dark:bg-slate-800 flex items-center justify-center text-slate-700 dark:text-slate-300">
                @if (game.isDarkMode()) {
                  <app-icon name="moon" [size]="16" class="text-indigo-400" />
                } @else {
                  <app-icon name="sun" [size]="16" class="text-amber-500" />
                }
              </div>
              <div>
                <div class="text-xs font-bold text-slate-900 dark:text-white">{{ game.t('settings.theme_title') }}</div>
                <div class="text-[11px] text-slate-500 dark:text-slate-400">
                  {{ game.isDarkMode() ? game.t('settings.theme_dark') : game.t('settings.theme_light') }}
                </div>
              </div>
            </div>
            <button
              type="button"
              (click)="game.toggleDarkMode()"
              id="btn-modal-toggle-theme"
              class="px-3 py-1.5 rounded-lg border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-xs font-semibold text-slate-700 dark:text-slate-200 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
            >
              {{ game.isDarkMode() ? game.t('nav.toggle_theme_light') : game.t('nav.toggle_theme_dark') }}
            </button>
          </div>

          <!-- Toggle de Notificaciones del Sistema -->
          <div class="flex items-center justify-between p-4 rounded-xl border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-950">
            <div class="flex items-center space-x-3 mr-3">
              <div
                class="w-8 h-8 rounded-lg flex items-center justify-center shrink-0 transition-colors"
                [ngClass]="game.notificationsEnabled() ? 'bg-emerald-100 dark:bg-emerald-950/60 text-emerald-700 dark:text-emerald-400' : 'bg-slate-200 dark:bg-slate-800 text-slate-500 dark:text-slate-400'"
              >
                <app-icon [name]="game.notificationsEnabled() ? 'bell' : 'bell-off'" [size]="16" />
              </div>
              <div>
                <div class="text-xs font-bold text-slate-900 dark:text-white flex items-center space-x-2">
                  <span>{{ game.t('settings.notifications_title') }}</span>
                  <span
                    class="px-1.5 py-0.2 rounded text-[10px] font-semibold"
                    [ngClass]="game.notificationsEnabled() ? 'bg-emerald-100 dark:bg-emerald-950/80 text-emerald-800 dark:text-emerald-300' : 'bg-amber-100 dark:bg-amber-950/80 text-amber-800 dark:text-amber-300'"
                  >
                    {{ game.notificationsEnabled() ? game.t('settings.notifications_enabled') : game.t('settings.notifications_disabled') }}
                  </span>
                </div>
                <div class="text-[11px] text-slate-500 dark:text-slate-400 mt-0.5">
                  {{ game.t('settings.notifications_desc') }}
                </div>
              </div>
            </div>

            <!-- Botón Switch / Toggle -->
            <button
              type="button"
              role="switch"
              [attr.aria-checked]="game.notificationsEnabled()"
              (click)="game.toggleNotifications()"
              id="btn-modal-toggle-notifications"
              class="relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none"
              [ngClass]="game.notificationsEnabled() ? 'bg-emerald-600' : 'bg-slate-300 dark:bg-slate-700'"
              [title]="game.notificationsEnabled() ? 'Desactivar avisos (solo errores)' : 'Activar todos los avisos'"
            >
              <span
                class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                [ngClass]="game.notificationsEnabled() ? 'translate-x-5' : 'translate-x-0'"
              ></span>
            </button>
          </div>

          <!-- Selector de 
          <div class="space-y-2">
            <div class="text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400">
              {{ game.t('nav.language') }}
            </div>
            <div class="grid grid-cols-2 gap-2">
              @for (lang of game.i18n.availableLanguages; track lang.code) {
                <button
                  type="button"
                  (click)="selectLanguage(lang.code)"
                  [id]="'modal-lang-' + lang.code"
                  class="flex items-center space-x-3 p-3 rounded-xl text-left cursor-pointer transition-all border"
                  [ngClass]="game.i18n.currentLanguage() === lang.code ? 'bg-emerald-50 dark:bg-emerald-950/50 text-emerald-700 dark:text-emerald-400 font-bold border-emerald-300 dark:border-emerald-800 shadow-xs' : 'bg-white dark:bg-slate-900 text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 border-slate-200 dark:border-slate-800'"
                >
                  <span class="text-xl">{{ lang.flag }}</span>
                  <div>
                    <div class="text-xs">{{ lang.nativeName }}</div>
                    <div class="text-[10px] text-slate-400 font-mono uppercase">{{ lang.shortCode }}</div>
                  </div>
                </button>
              }
            </div>
          </div>Idioma -->
        }

        <!-- TAB 3: PERFIL -->
        @if (activeTab() === 'profile') {
          @if (game.currentUser(); as user) {
            <div class="p-4 rounded-xl border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-950 space-y-3">
              <div class="flex items-center space-x-3">
                <div class="w-12 h-12 rounded-2xl bg-gradient-to-tr from-emerald-600 to-teal-500 text-white flex items-center justify-center font-bold text-lg shadow-sm">
                  {{ user.name.charAt(0) || 'M' }}
                </div>
                <div>
                  <h4 class="font-bold text-sm text-slate-900 dark:text-white">{{ user.name }}</h4>
                  <p class="text-xs text-slate-500 dark:text-slate-400">{{ user.email }}</p>
                  <span class="inline-block mt-1 px-2 py-0.5 rounded text-[10px] font-semibold bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-800">
                    {{ user.role }}
                  </span>
                </div>
              </div>

              @if (game.userClub(); as club) {
                <div class="pt-3 border-t border-slate-200 dark:border-slate-800 flex items-center justify-between text-xs">
                  <span class="text-slate-500 dark:text-slate-400">{{ game.t('settings.profile_club') }}:</span>
                  <span class="font-bold text-slate-900 dark:text-white flex items-center space-x-2">
                    <div class="w-4 h-5 flex items-center justify-center shrink-0">
                      <app-club-shield [club]="club" size="xs" />
                    </div>
                    <span>{{ club.name }}</span>
                  </span>
                </div>
              }
            </div>

            <div class="pt-2">
              <button
                type="button"
                (click)="handleLogout()"
                id="modal-btn-logout"
                class="w-full py-2.5 px-4 rounded-xl text-rose-600 dark:text-rose-400 bg-rose-50 hover:bg-rose-100 dark:bg-rose-950/40 dark:hover:bg-rose-950/60 border border-rose-200 dark:border-rose-900/60 text-xs font-bold cursor-pointer transition-colors flex items-center justify-center space-x-2"
              >
                <app-icon name="log-out" [size]="15" />
                <span>{{ game.t('settings.profile_logout') }}</span>
              </button>
            </div>
          }
        }
      </div>
    </div>
  </div>
}
